<template>
  <div id='' class='gPageBorder' v-loading='loading'>

    <tyc :tqobj='tqobj'></tyc>
    <div id=''>
      <el-table
        @row-click='cellClick'
        :data="tableData"
        border
        class='tbPoint'
        style="width: 100%;border:none;">
        
        <el-table-column
          header-align='center'
          align='center'
          prop="fileName"
          :label="$t('app_appName')"
          width="">
        </el-table-column>
        
        <el-table-column
          header-align='center'
          align='center'
          prop="fileVersion"
          width=''
          :label="$t('app_version')">
        </el-table-column>

        <!-- <el-table-column
          header-align='center'
          align='center'
          prop="fileType"
          :formatter="setft"
          width='115'
          :label="$t('app_filetype')">
        </el-table-column>

        <el-table-column
          header-align='center'
          align='center'
          prop="subFileType"
          :formatter="setsbt"
          width='120'
          :label="$t('app_subtype')">
        </el-table-column> -->

        <el-table-column
          header-align='center'
          align='center'
          prop="mechName"
          width=''
          :label="$t('app_distributor')">
        </el-table-column>

        <el-table-column
          header-align='center'
          align='center'
          prop="fileStatus"
          width='115'
          :label="$t('app_status')">
          <template slot-scope='scope'>
            <label :style='getStatus(scope.row.fileStatus).style'>{{getStatus(scope.row.fileStatus).vl}}</label>
          </template>
        </el-table-column>

        <el-table-column
          header-align='center'
          align='center'
          prop="createTime"
          width='175'
          :label="$t('app_addtime')">
        </el-table-column>
        
        <el-table-column
          header-align='center'
          align='center'
          prop="operate"
          width='84'
          :label="$t('app_operate')">
          <template slot-scope='scope'>
            <el-tooltip class="item" effect="dark" :content="$t('app_verify')" placement="top">
              <el-button type='text'><i class="fa fa-check-square-o" style=""></i></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <div class="gPgDiv" style=''>
        <el-pagination
        class='gPg'
        @current-change="pageSelect"
        @size-change="pageSized"
        :current-page="index"
        :page-sizes='$gRows'
        :page-size="$gRow"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<style>
  /* html,body{width:100%;height:100%;}*/

  .tbPoint td{cursor:pointer}

  .cmMarginFrame{width:calc(100% - 20px);height:100%;background:none;margin-left:10px;}

  #appDepot{min-width:840px;}

  #adData{}

  
    
</style>

<script>
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  import mm from 'moment'
  import tyc from '@/components/global/tyc.vue'
  export default{
    components: {
      MechanismSelector,
      tyc
    },
    
    data () {
      var that = this;
      return {
        tqobj: '',
        mechanismData: {
          callback (value) {
            // that.mech = value
            that.selectChange(value)
          }
        },
        listKey: 'launch-list',
        cerDialogVisible: false,
        cerTipDialogVisible: false,
        dvLoading: 0,
        appId: '',
        stModel: [
          {label: this.$t('app_online'), vl: '1'},
          {label: this.$t('app_offline'), vl: '2'},
          {label: this.$t('app_new'), vl: '0'}
        ],
        channels: [],
        cmsts: [],
        srchValue: '',
        channelId: '',
        cerTipMsg: '',
        status: '',
        dvIndex: 1,
        ftype: '',
        sftype: '',
        dialogVisible: 0,
        mechanismId: window.localStorage['mechanismId'],
        selectMid: '',
        tableData: [],
        dvTableData: [],
        appTypes: [],
        appTypeValue: '',
        appStatus: [
          {label: this.$t('app_prePushVerify'), value: '0'},
          {label: this.$t('app_preVerify'), value: '1'},
          {label: this.$t('app_verifyPass'), value: '2'},
          {label: this.$t('app_verifyNotPass'), value: '3'}
        ],
        appStatusValue: '',
        total: 0,
        dvTotal: 0,
        loading: 0,
        appType: '',
        queryKey: '',
        ftypes: '',
        getftype: '',
        sftypes1: [],
        sftypes2: [],
        sftypes3: [],
        sftypes5: [],
        sftypes6: [],
        sftypes7: [],
        sftypes9: [],
        sftypes10: [],
        getsftype: ''
      }
    },
    computed: {
      index () {
        var vl = this.$getWPage(this.listKey)
        return vl ? vl : 1
      },
      getDvStatus (value) {
        switch (value) {
          case '0':
            return this.$t('app_prePushVerify')
          case '1':
            return this.$t('app_preVerify')
          case '2':
            return this.$t('app_verifyPass')
          case '3':
            return this.$t('app_verifyNotPass')
        }
      }
    },
    methods: {
      fileTypeChange (vl) {
        this.sftype = ''
        if (!vl) {
          this.cmsts = ''
        } else 
        this.cmsts = this['sftypes' + vl]
        this.getList()
      },
      setft (row) {
        return this.getftype[row.fileType]
      },
      setsbt (row) {
        
        var vl = this.getsftype[row.subFileType]
        return vl
        
      },
      pushCreateCer () {
        this.$router.push({path: "/certificate/new"})
      },
      pushUploadCer () {
        this.$router.push({path: "/certificate/upload"})
      },
      bindOperate (row) {
        //console.log(row)
        
        this.dvLoading = 1
        if (this.$appUrlTag === 0) {
          this.$bindApp('0', row.terminalNo, this.appId, (res) => {
            if (res.status === 200) {
              this.$message.success(this.$t('app_tipViewTask'))
            } else {
              this.$message.error(res.message)
            }
            this.dvLoading = 0
          }, () => {
            // error
            this.dvLoading = 0
          })
        } else {
          // console.log(localStorage.mechanismId, tNo)
          this.$bindApp1(localStorage.mechanismId, row.terminalNo, this.appId, (res) => {
            if (res.status === 200) {
              this.$message.success(this.$t('app_tipViewTask'))
            } else {
              this.$message.error(res.message)
            }
            this.dvLoading = 0
          }, () => {
            // error
            this.dvLoading = 0
          })
        }
      },
      getChannels () {
        this.$getChannelList(10000, 1, '', '', '', (res) => {
          if (res.status === 200) {
            this.channels = res.data
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      getStatus (value) {
        if (!value) return ''
        switch (value) {
          case '0':
            return {vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;'}
          case '1':
            return {vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;'}
          case '2':
            return {vl: this.$t('app_verifyPass'), style: 'color:#13CE66;'}
          case '3':
            return {vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;'}
        }
      },
      srchDevice () {
        this.getDevices()
      },
      selectDvChange (vl) {
        this.getDevices()
      },
      pageDvSized (val) {
        this.$gRow = val
        this.getDevices()
      },
      getDevices () {
        var vl = this.srchValue ? this.srchValue : ''
        var channel = this.channelId ? this.channelId : ''
        var status = this.status ? this.status : ''
        var appId = this.appId ? this.appId : ''
        this.dvLoading = 1
        if (this.$appUrlTag === 0) {
          this.$getDevices(this.dvIndex, this.$gRow, channel, vl, status, '', appId, (res) => {
            // console.log('dv', res)
            this.dvLoading = 0
            if (res.data) {
              this.dvTableData = res.data
              this.dvTotal = res.total
            }
          }, () => {
            // error
            this.dvLoading = 0
          })
        } else {
          
          this.$getDevices1(this.dvIndex, this.$gRow, localStorage.mechanismId, vl, status, '', appId, (res) => {
            console.log('dv', res)
            this.dvLoading = 0
            if (res.data) {
              this.dvTableData = res.data
              this.dvTotal = res.total
            }
          }, () => {
            // error
            this.dvLoading = 0
          })
        }
        
      },
      editApp (row) {
        this.$setWObj('fileEdit', {type: 1, data: row})
        this.$router.push({path: '/filemg/edit'})
      },
      pushApp (row) {
        
        //this.$setWObj('launcherPush', row)
        //this.$router.push({path: '/launch-push'})

        this.$setWObj('pushList', {type: '10', data: row})
        this.$router.push({path: '/launch-push'})
       
      },
      query () {
        this.getList()
      },
      selectChange (vl) {
        this.selectMid = vl
        this.getList()
      },
      reset () {
        this.queryKey = ''
        this.appType = ''
        this.getList()
      },
      pageSelect (index) {
        this.$setWPage(this.listKey, index)
        this.getList()
      },
      pageDvSelect (index) {
        this.dvIndex = index
        this.getDevices()
      },
      pageSized (val) {
        this.$gRow = val
        this.getList()
      },
      deleteApp (obj) {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          console.log(obj)
          this.$delfile(obj.fileId, (res) => {
            if (res.status === 200) {
              this.getList()
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
          }, '')
        }, '')
      },
      submitApp (obj) {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_tipVerify'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          this.loading = 1
          this.$verifyFile(obj.fileId, '', '1', (res) => {
            this.loading = 0
            if (res.status === 200) {
              this.getList()
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            this.loading = 0
          })
          
        }, '')
      },
      cellClick (row, ev, col) {
        // if (col.label && col.label === this.$t('app_operate')) {
        //   return
        // }
      
        //console.log(row)
        // var isDetail = (row.status === '1' || row.status === '2')
        // var path = isDetail ? '/launch-detail' : '/launch-edit'
        // var key = isDetail ? 'launcherDetail' : 'launcherEdit'
        // var obj = isDetail ? row : {type: 1, data: row}

        this.$setWObj('fileDetail', row)
        // this.$router.push({path: '/filemg/vlist/verify'})
        this.$router.push({path: '/non-it-eq/app/verify'})
        
      },
      jumpToUpload () {
      
        this.$setWObj('fileEdit', {type: 0})
        this.$router.push({path: '/filemg/add'})
      },
      getList () {
        this.loading = 1
        var mech = this.selectMid ? this.selectMid : '' //渠道商id
        var name = this.queryKey ? this.queryKey : ''
        var type = '6'
        var stype = '6-1'
        var st = '1'

        this.$getfile(this.index, this.$gRow, name, mech, type, stype, st, '', '', (res) => {
          
          this.loading = 0
          if (res.status === 200) {
            this.total = res.total
            this.tableData = res.data
          } else {
            this.$message(res.message)
          }
        }, () => {
          this.loading = 0
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      dateFormat (row, column) {
        var date = row[column.property]
        if (date === undefined) {
          return ''
        }
        return mm(date).format('YYYY-MM-DD HH:mm:ss')
      },
      setInstallType (type) {
        return this.$installType[type]
      }
    },
    mounted () {
     
      this.tqobj = {
        keys: ['ftypes','ftype','sftype','sftypes1','sftypes2','sftypes3','sftypes4','sftypes5','sftypes6','sftypes7','sftypes9'],
        callback: (data) => {
          this.ftypes = data[0]
          this.getftype = data[1]
          this.getsftype = data[2]
          this.sftypes1 = data[3]
          this.sftypes2 = data[4]
          this.sftypes3 = data[5]
          this.sftypes4 = data[6]
          this.sftypes5 = data[7]
          this.sftypes6 = data[8]
          this.sftypes7 = data[9]
          this.sftypes9 = data[10]
        }
      }
      // helper.say()
      //this.getChannels()
      this.getList()
      /*this.$getAppTypeList(100000000, 1, (res) => {
        if (res.status === 200) {
          this.appTypes = res.data
        } else {
          this.$message(res.message)
        }
      }, '')*/
    },
    destroyed () {
    }
  }
</script>



// WEBPACK FOOTER //
// vlist.vue?6ee96812